// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bonus-box {
  cursor: pointer;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  width: 160px;
  height: fit-content;
  overflow: hidden;
}
.bonus-box img {
  min-width: 100%;
  min-height: 100%;
}

.bonus-amount-box {
  border-radius: 8px 8px 0 0;
  background-color: black;
  color: white;
  width: 160px;
  overflow: hidden;
}
.bonus-amount-box img {
  min-width: 100%;
  min-height: 100%;
}

.selected-offer-bonus-amount-box {
  background-color: black;
  color: white;
  width: 160px;
  overflow: hidden;
}
.selected-offer-bonus-amount-box img {
  min-width: 100%;
  min-height: 100%;
}

.rewards-points-box {
  border-radius: 0 0 8px 8px;
  padding: 10px;
  background-color: var(--ion-color-secondary);
  color: white;
}

.selected-offer-rewards-box {
  padding: 8px;
  background-color: var(--ion-color-primary);
  color: white;
}

p, h3 {
  margin: 0;
}

.overlay {
  border-radius: 8px 8px 0 0;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  width: 158px;
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5);
  transition: 0.5s ease;
  opacity: 1;
  color: white;
  padding: 2px;
  display: block;
  background-color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/boyd-rewards/boyd-redeem-rewards/boyd-redeem-rewards.component.scss"],"names":[],"mappings":"AAKA;EACI,eAAA;EACA,4CAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAKI;EACI,eAAA;EACA,gBAAA;AAHR;;AAOA;EACI,0BAAA;EAEA,uBAAA;EACA,YAAA;EACA,YAAA;EAEA,gBAAA;AANJ;AAOI;EACI,eAAA;EACA,gBAAA;AALR;;AAQA;EAEI,uBAAA;EACA,YAAA;EACA,YAAA;EAEA,gBAAA;AAPJ;AAQI;EACI,eAAA;EACA,gBAAA;AANR;;AAUA;EACI,0BAAA;EACA,aAAA;EACA,4CAAA;EACA,YAAA;AAPJ;;AASA;EAEI,YAAA;EACA,0CAAA;EACA,YAAA;AAPJ;;AASA;EACI,SAAA;AANJ;;AAQA;EACI,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,8BAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;AALJ","sourcesContent":[".selected-offer {\r\n\r\n}\r\n\r\n\r\n.bonus-box {\r\n    cursor: pointer;\r\n    border: 1px solid var(--ion-color-secondary);\r\n    border-radius: 8px;\r\n    width: 160px;\r\n    height: fit-content;\r\n    overflow: hidden;\r\n    img {\r\n        min-width: 100%;\r\n        min-height: 100%;\r\n    }\r\n}\r\n\r\n.bonus-amount-box {\r\n    border-radius: 8px 8px 0 0;\r\n    // padding: 40px;\r\n    background-color: black;\r\n    color: white;\r\n    width: 160px;\r\n    // height: 145px;\r\n    overflow: hidden;\r\n    img {\r\n        min-width: 100%;\r\n        min-height: 100%;\r\n    }\r\n}\r\n.selected-offer-bonus-amount-box {\r\n    // padding: 20px;\r\n    background-color: black;\r\n    color: white;\r\n    width: 160px;\r\n    // height: 145px;\r\n    overflow: hidden;\r\n    img {\r\n        min-width: 100%;\r\n        min-height: 100%;\r\n    }\r\n}\r\n\r\n.rewards-points-box {\r\n    border-radius: 0 0 8px 8px;\r\n    padding: 10px;\r\n    background-color: var(--ion-color-secondary);\r\n    color: white;\r\n}\r\n.selected-offer-rewards-box {\r\n    \r\n    padding: 8px;\r\n    background-color: var(--ion-color-primary);\r\n    color: white;\r\n}\r\np,h3 {\r\n    margin: 0;\r\n}\r\n.overlay {\r\n    border-radius: 8px 8px 0 0;\r\n    position: absolute;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 158px;\r\n    background: rgb(0, 0, 0);\r\n    background: rgba(0, 0, 0, 0.5);\r\n    transition: 0.5s ease;\r\n    opacity: 1;\r\n    color: white;\r\n    padding: 2px;\r\n    display: block;\r\n    background-color: var(--ion-color-primary);\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
